import React, { Component } from 'react'

import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'

export default class DisableUser extends Component<any> {
  state = {
    loading: false,
    show: true,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      this.setState({ loading: false, show: true, })
  }

  onModalConfirm = () => {
    this.setState({ loading: true })

    let chgStatus = this.props.open.curStatus === null ? true : !this.props.open.curStatus
    this.props.callback(this.props.open.val, chgStatus, this.props.open.key).then(isSuccess => {
      isSuccess ? this.setState({ show: false }) : this.setState({ loading: false })
    })
  }

  render() {
    // console.log(this.state)
    let curStatus = this.props.open.curStatus
    return (
      <Modal show={this.state.show && this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {'Are you sure you want to ' + (curStatus !== true ? "enable" : "disable") + ' this item?'}
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle={(curStatus !== true ? "success" : "danger")}
            loading={this.state.loading}
            onClick={this.onModalConfirm}
            disabled={false}>
            {this.state.loading ? 'Please wait' : (curStatus !== true ? "Enable" : "Disable")}
          </Button>
          <Button bsStyle="default" onClick={() => { this.setState({ show: false }) }}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}